import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    desktopContainer: {
      display: "flex",
      minHeight: "100vh",
    },
    desktopSidebar: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        background: "linear-gradient(180deg, #2a4468 0%, #315179 100%)",
        display: "flex",
        flexDirection: "column",
        flex: "0 0 auto",
        width: "min(26vw, 300px)",
      },
    },
    sidebarLogoWrap: {
      padding: "36px 32px 0",
      "& img": {
        width: "100%",
        maxWidth: 300,
      },
    },
    // The right-hand side — navy on mobile, light gray canvas on desktop
    baseContainer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      minHeight: "100vh",
      background: "linear-gradient(180deg, #2a4468 0%, #315179 100%)",
      [theme.breakpoints.up("sm")]: {
        background: "#eef1f5",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(4),
      },
    },
    // Mobile: logo sits at the top on the navy background
    logoBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(5, 0, 3),
      "& img": {
        width: "55%",
        maxWidth: 200,
      },
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    // White card on desktop, transparent on mobile
    card: {
      width: "100%",
      padding: theme.spacing(3, 3, 2),
      [theme.breakpoints.up("sm")]: {
        maxWidth: 420,
        backgroundColor: "#fff",
        borderRadius: 12,
        boxShadow: "0 4px 24px rgba(0,0,0,0.09), 0 1px 4px rgba(0,0,0,0.06)",
        padding: theme.spacing(5, 5, 4),
      },
    },
    content: {
      flexGrow: 1,
    },
    footerBox: {
      color: "lightgrey",
      textAlign: "center",
      marginTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      fontSize: "0.8rem",
      [theme.breakpoints.up("sm")]: {
        color: "grey",
      },
    },
  }),
  {
    classNamePrefix: "AuthAreaLayout",
  },
);